import React, {FunctionComponent, Fragment, useContext} from 'react';
import {observer} from "mobx-react";
import TranslatedText from "../../../ui/TranslatedText/TranslatedText";
import TranslatedNode from "../../../ui/TranslatedNode/TranslatedNode";
import {Typography} from "@material-ui/core";
import UITranslations from "../../../../store/uiTranslations";
import {Context} from "../../../../store/context";
import TranslatedNodeDestination from '../../../ui/TranslatedNode/TranslatedNodeDestination';

interface IEnterAtItem{
    parkTheCar:boolean,
    isAlternative:boolean;
}

const EnterAtItem:FunctionComponent<IEnterAtItem> = ({parkTheCar, isAlternative}) => {
    const ui = UITranslations.GettingToPage.Wizard.Entrance;

    const {gettingToPageStore} = useContext(Context);
    const {settings} = gettingToPageStore;

    if(!settings)
        return null;

    const enterAtText = parkTheCar ? ui.EnterAt : ui.DropOff;
    const entranceId = parkTheCar ?
        (isAlternative ? settings.alternativeEntranceId : settings.preferredEntranceId) :
        settings.pedestrianEntranceId;

    return <Typography gutterBottom>
        <TranslatedText source={enterAtText}/>
        {' '}
        <strong><TranslatedNodeDestination id={entranceId as any}/></strong>
    </Typography>
}

export default observer(EnterAtItem);
